import Location from '../../../hooks/Location';
import { useEffect, useState, useContext, Fragment } from 'react';
import { useFirestoreGeneral, useFirestoreID, useFirestoreOrderBy } from '../../../firebase/useFirestore';
import { SavedIcon } from "../../../StateManagment/SavedIcon";
import { db, timestamp } from '../../../firebase/config';
import ButtonClickedSimple from '../../../hooks/ButtonClickedSimple';
import { Auth } from '../../../StateManagment/Auth'
import { Responses } from "../../../StateManagment/Responses";
import { client } from "../../../hooks/Client";
import uuid from 'react-uuid';
import timestampToDateInput from '../../../utils/timestampToDateInput';
import firebase from '../../../firebase/compat';
import EffectMeta from '../../effects/EffectMeta';
import NotesAttachments from './NotesAttachments';
import ReadOnlyGuard from '../../common/ReadOnlyGuard';
import AutosaveStatus from '../../common/AutosaveStatus';
import useAutosaveField from '../../../hooks/useAutosaveField';

const PersonaReportDetail = () => {
  // Context
  const [saved, setSaved] = useContext(SavedIcon);
  const [auth] = useContext(Auth)
  const [responses, setResponses] = useContext(Responses);

  // State
  const [body, setBody] = useState('');
  const [docid, setDocid] = useState('');
  const [date, setDate] = useState('');
  const [pairedGoals, setPairedGoals] = useState([]);
  const [checkedGoals, setCheckedGoals] = useState([]);
  const [title, setTitle] = useState('');

  // Hooks
  const { save, status } = useAutosaveField('PersonaReports');
  const reportId = Location()[4];
  const personaId = Location()[3];
  const compagnyId = Location()[1];
  const options = { year: 'numeric', month: 'numeric', day: 'numeric' };

  // Firestore
  const report = useFirestoreID('PersonaReports', reportId ? reportId : '');
  const goals = useFirestoreGeneral('PersonaGoals', 'PersonaID', personaId ? personaId : '');
  const reportStandards = useFirestoreOrderBy('PersonaReportStandard', 'Position', 'asc')

  // Set docid of goal in state and initialize pairedGoals and checkedGoals
  useEffect(() => {
    report && report.forEach(item => {
      setBody(item.Body);
      setDocid(item.docid);
      setTitle(item.Title);
      setDate(item.Timestamp.toDate().toLocaleDateString("nl-NL", options));
      setPairedGoals(item.Goals || []);
      setCheckedGoals(item.Goals ? item.Goals.map(id => ({ id })) : []);
    });
  }, [report]);

  // Deze pagina heeft bewust geen opslaanknop: wijzigingen worden vanzelf
  // bewaard. `useAutosaveField` doet dat niet per toetsaanslag maar zodra de
  // gebruiker even stopt, en schrijft bij het verlaten van de pagina alsnog weg
  // wat er nog klaarstaat — anders gaat de laatste zin verloren (inbox #155).
  // Het meldt ook 'Opgeslagen' zodra de schrijfactie geslaagd is (inbox #151).
  const bodyHandler = (e) => {
    save(e.target.dataset.docid, { Body: e.target.value });
  };


  // Toggle selected goals
  const handleCheckboxChange = (id, docid) => {
    setCheckedGoals(prevState => {
      const isSelected = prevState.some(goal => goal.id === id);
      if (isSelected) {
        // Remove the goal if it was selected
        return prevState.filter(goal => goal.id !== id);
      } else {
        // Add the goal if it was not selected
        return [...prevState, { id, docid }];
      }
    });
  };

  // Save the selected goals to firestore
  const saveGoals = (e) => {

    ButtonClickedSimple(e, 'Opslaan...', 'Opslaan');

    // Get all goal IDs
    const goalIds = checkedGoals.map(goal => goal.id); 

    db.collection('PersonaReports')
      .doc(docid)
      .update({
        Goals: goalIds
      });
      // Update pairedGoals to reflect saved state
    setPairedGoals(goalIds); 

    // Save the indicator results of the selected goals to firestore
    const formID = uuid();

    responses &&
        responses.map(response => {
            db.collection('QuestionnairesResponses')
                .doc()
                .set({
                    FieldID: response.FieldID,
                    Input: response.Input,
                    Timestamp: timestamp,
                    CompagnyID: client,
                    QuestionannaireID: '',
                    MomentID: '',
                    ResearchID: '',
                    FormID: formID,
                    ID: uuid(),
                    OptionType: response.OptionType ? response.OptionType : '',
                    Persona: personaId ? personaId : '',
                    RowTitle: response.RowTitle ? response.RowTitle : '',
                    RowTitleRight: response.RowTitleRight ? response.RowTitleRight : '',
                    FieldType: response.FieldType ? response.FieldType : '',
                    ColumnID: response.ColumnID ? response.ColumnID : '',
                    User: auth.ID,
                    Support: true
                })
                .then(() => {
                    setSaved(true);
                });
        });
  };

  // Handle title changes
  const titleHandler = (e) => {
    setTitle(e.target.value);
    save(docid, { Title: e.target.value });
  };

  // Handle date changes
  const dateHandler = (e) => {
    const selectedDate = new Date(e.target.value);
  
    save(docid, { Timestamp: firebase.firestore.Timestamp.fromDate(selectedDate) });
  };

  return (
    <div className="main">
      <div className="main-container">
        <div className="page-header">
          <h1>Notitie aanpassen</h1>
          <p>{date}</p>
        </div>
        <AutosaveStatus status={status} />
        <ReadOnlyGuard edit="personas.edit">
          {report && report.map(item => (
            <Fragment key={item.ID}>
              <div className="dashboard-container">
                <h2>Titel</h2>
                <input type="text" defaultValue={item.Title} onChange={titleHandler}/>
              </div>
              <div className="dashboard-container">
                <h2>Datum</h2>
                <input type="date" defaultValue={timestampToDateInput(item.Timestamp)} onChange={dateHandler}/>
              </div>
              <div className="dashboard-container">
                <h2>Rapportage</h2>
                <textarea defaultValue={item.Body} placeholder='Schrijf hier je rapportage' data-docid={item.docid} onChange={bodyHandler}></textarea>
              </div>
            </Fragment>
          ))}
        </ReadOnlyGuard>

        <div className="dashboard-container">
          <NotesAttachments
            parentId={reportId}
            parentType="personaReport"
          />
        </div>

        {/* <div className="dashboard-container">
          <h2>Doelen</h2>
          <p>Selecteer de effecten waarop deze rapportage betrekking heeft:</p>
          {goals && goals.map(goal => (
            <div key={goal.ID}>
              <div id='persona-goal-item-container'>
                <input 
                  type="checkbox" 
                  checked={checkedGoals.some(q => q.id === goal.ID)}
                  onChange={() => handleCheckboxChange(goal.ID, goal.docid)}
                />
                <p>{<EffectMeta item={goal.EffectId} />}</p>
              </div>
              {checkedGoals.some(q => q.id === goal.ID) && 
                <div id='persona-report-score-effects-item-container'>
                  <PersonaReportScoreEffects goalId={goal.ID} reportId={reportId} />
                </div>
              
            </div>
          ))}
          <button className="button-simple" onClick={saveGoals}>Opslaan</button>
        </div> */}
      </div>
    </div>
  );
};

export default PersonaReportDetail;
